import Vue, { PluginObject } from 'vue'

const messages: Map<number, string> = new Map([
])

class CodesPlugin implements PluginObject<any> {
  install = (_Vue: typeof Vue, options?: any) => {
    _Vue.prototype.$codes = function (object: any) {
      var message = 'Erro desconhecido. Contate o suporte.'
      
      if (object.response.status == 403 && !object.response.config.url.includes("/api/login")) {
        message = 'Você foi deslogado, realize novamente o login para continuar utilizando a plataforma.'
        return message;
      }

      if (object.response.status === 405) {
        message = 'Sua conta ainda não foi verificada! Verifique seu e-mail para ativá-la.';
      } else if (object.response.status === 401 && !object.response.config.url.includes("/api/login")) {
        message = 'Sem acesso a este recurso!';
      }

      // if (object.response.status == 401 && !object.response.config.url.includes("/api/login")) {
      //   message = 'Sem acesso a este recurso.'
      //   return message;
      // }

      if (object && object.response && object.response.data.content) {
        const errorTmp = object.response.data.content.error;

        message = errorTmp.message || 'nenhuma informação disponível'
      }

      return message
    }
  };
  [key: string]: any
}

const plugin = new CodesPlugin()
Vue.use(plugin)
